/*
    Templating generic fields
*/
define('shared/initializer/form/adapters/mixins/Templatable',[
    '$',
    'shared/initializer/die',
    'shared/lib/beam',
    'shared/lib/RSVP',
    'shared/lib/console',
    'shared/lib/Emitter',
    'shared/remote/data/get',
    'shared/util/state',
    'shared/util/hub',
    'shared/page/market',
    'shared/page/language'
], 
function (
    $,
    die,
    beam,
    RSVP,
    console,
    Emitter,
    getData,
    state,
    hub,
    getMarket,
    getLanguage
) {
    'use strict';

    var razor = window.razor;
    var uniqueClasses = {};
    var HUB_PATH = 'templatable';
    var templateCache = {};

    function generateUniqueClass() {
        var id = 'unique-' + Date.now() + (Math.random() * 10000 >> 0);
        if (id in uniqueClasses) {
            return generateUniqueClass();
        }
        uniqueClasses[id] = true;
        return id;
    }

    function handleItem(key, item){
        var me = this;
        var prm;
        var mkt;
        var lng;

        item.sourceName = item.$el.attr('data-source');
        item.compiled = item.$el.attr('data-compiled');
        item.compiled = item.compiled != null && item.compiled != ''?true:false;
        item.fieldName = item.$el.attr('name');
        item.sourceHTML = item.$el.html();

        if (item.compiled) {
            item.template = function(model){
                var func = window.eval('(' + item.sourceHTML + ')');
                if (typeof func === 'function') {
                    return func( model, new razor.helpers.constructor( model ), {}, null );
                }
                return 'Template is not compiled';
            };
        }
        else if (templateCache[item.sourceHTML]) {
            item.template = templateCache[item.sourceHTML];
        }
        else {
            item.template = me.options.template.engine.compile(item.sourceHTML);
            templateCache[item.sourceHTML] = item.template;
        }

        if (item.sourceName != null && item.sourceName !== '') {
            prm = getData({
                source: {
                    name: item.sourceName
                }
            });
        }
        else {
            prm = RSVP.resolve({});
        }

        return prm
            .then(function(x){
                return RSVP.resolve()
                    .then(function(){
                        return getLanguage();
                    })
                    .then(function(language){
                        lng = language;
                    })
                    .then(function(){
                        return getMarket();
                    })
                    .then(function(market){
                        mkt = market;
                    })
                    .then(function(){
                        return RSVP.resolve(x);
                    });
            })
            .then(function(x){
                var emitter = hub.peek(HUB_PATH);
                if (emitter == null) {
                    me.emitter = new Emitter();
                    hub.set(HUB_PATH, me.emitter);
                }
                else {
                    me.emitter = emitter;
                }
                return RSVP.resolve(x);
            })
            .then(function(data){
                item.data = data;
                item.id = generateUniqueClass();
                item.data.cssClass = '.' + item.id;
                item.data.id = item.id;
                item.data.fieldName = item.fieldName;
                item.data.market = mkt;
                item.data.language = lng;
                item.data.scriptTagName = 'script';
                // compile the template
                console.log('About to render:', 'rendered/' + item.id, item.data, {html: item.sourceHTML});
                item.html = item.template(item.data);
                // build dom
                var $dom = $(item.html).addClass(item.id);
                item.$dom = $dom;
                item.$wrap.append($dom);
                var $input = $(document.createElement('input'));
                $input.attr('name', item.fieldName);
                $input.attr('type', 'hidden');
                item.$input = $input;
                item.$wrap.append($input);
                me.emitter.reemit('rendered/' + item.id, item.data);

                return die.init($dom.filter('.' + item.id + ':not(style,script)'));
            });
    }

    function handleItemValidate(item){
        var me = this;
        var holder = {};
        var promise;
        
        me.emitter.emit('validate/' + item.id, holder);

        if (holder.promise) {
            promise = holder.promise;
        }
        else {
            promise = RSVP.resolve();
        }

        return promise.then(function(){
            me.emit('validationpass', item);
        }, function(reason){
            var msg = reason instanceof Error? reason.message:reason+'';
            me.emit('validationfail', item, msg);
            return RSVP.reject(msg);
        });
    }

    function Ctor() {
        var me = this;
        me.generics = {};

        me.$form.parent().addClass('templatable');

        if (
            me.options.template == null ||
            me.options.template.engine == null ||
            typeof me.options.template.engine.compile !== 'function'
        ) {
            throw new Error('Templatable cannnot be instantiated because lack of start up options.');
        }
    }

    var p = Ctor.prototype;
    p.doPageLoad = function() {
        var me = this;
        var generics = me.generics;
        return RSVP.resolve()
            // hide none generic field
            // and retrieve all generic items
            .then(function(){
                function createValidationWrapper(item) {
                    return function handleItemValidateWrapper(){
                        return handleItemValidate.call(me, item);
                    };
                }
                for(var key in me.items) {
                    if (me.items.hasOwnProperty(key) === false){
                        continue;
                    }

                    var item = me.items[key];

                    if (item.$el == null) {
                        continue;
                    }

                    if (item.$el.prop('tagName').toUpperCase() !== 'SCRIPT'){
                        if (me.type  === 'generic') {
                            item.$wrap.hide();
                        }
                    }
                    else {
                        item.validate = createValidationWrapper(item);
                        generics[key] = item;
                    }
                }
            })
            // for each generic field, download template and data
            .then(function(){
                var prms = [];

                for(var key in generics){
                    if (generics.hasOwnProperty(key) === false){
                        continue;
                    }

                    prms.push(handleItem.call(me, key, generics[key]));
                }

                return RSVP.all(prms);
            })
            .then(function(){
                for(var key in generics){
                    if (generics.hasOwnProperty(key) === false){
                        continue;
                    }

                    generics[key].$wrap.show();
                    me.emitter.reemit('shown/' + generics[key].id);
                }
            });
    };

    p.doBeforeSubmit = function() {
        var me = this;
        var generics = me.generics;
        var holder;
        var currentPromise = RSVP.resolve();

        me.$form
            .removeClass('submission-successed')
            .removeClass('submission-failed');

        function iterate(item) {
            var iteratePromise;

            holder = {};

            me.emitter.emit('beforeSubmit/' + item.id, holder);

            if (holder.promise) {
                iteratePromise = holder.promise;
            }
            else {
                iteratePromise = RSVP.resolve();
            }

            return iteratePromise
                .then(function(){
                    if(item.value != null) {
                        item.$input.val(item.value);
                    }
                });
        }

        function loopBody(item) {
            currentPromise = currentPromise.then(function(){
                return iterate(item);
            });
        }

        for(var key in generics){
            if (generics.hasOwnProperty(key) === false){
                continue;
            }

            loopBody(generics[key]);
        }

        return currentPromise;
    };

    p.doAfterSubmit = function(data) {
        var me = this;
        var generics = me.generics;

        this.$form.addClass('submission-successed');

        for(var key in generics){
            if (generics.hasOwnProperty(key) === false){
                continue;
            }

            me.emitter.reemit('afterSubmit/' + generics[key].id);
        }

        return RSVP.resolve(data);
    };

    p.doSubmiFail = function() {
        this.$form.addClass('submission-failed');
        return RSVP.resolve();
    };

    return Ctor;
});
